import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    maVariable: "Bonjour",
    datesPrelevement: ["au 1er", "au 15", "au 25"],
    groupes: [
      "Gospel For You Family",
      "Black Harmony Gospel Singers",
      "Gospel Feel",
      "Gospel Celebration",
      "Angels",
      "Gospel Bayina Tribe",
      "Sankofa Unit",
      "Shine Gospel",
    ],
    urlFc:
      "https://script.google.com/macros/s/AKfycbwIjT1OSz4z7W8uh0hUYR6OHw7o2YfSYZlLuBREHJZnUYfoLnbyJlI7ImlmLX73-w6Y6w/exec",
    url: "https://script.google.com/macros/s/AKfycbxmvEnkdzCChrQ2SpD_A_UVx4QybDiiekE_gkVfrN2PZxgVByRuNPIUO3RtVM7AjDPo/exec",
    urlMail:
      "https://script.google.com/macros/s/AKfycbxy04bB76ynyd1-AA82ZJBJr5nkVZDRfqM_NAF2c6q5Ni6pdfMViT4q2TK2s2qXQBxeLw/exec",
    commerciaux: [],
    ClientsComptable: [],
    StatutsClientsComptable: [],
    SecteurActiviteSecure: [],
    Etat: [],
    Avencement: [],
    enquetSol: [],
    ProduitFamill: [],
    Orige: [],
    cgv: "Lorem ispum",
    currentUser: { status: "", dataFromGoogleAuth: {} },
  },
  mutations: {
    setProduitFamill(state, action) {
      state.ProduitFamill = action;
    },
    setenquetSol(state, action) {
      state.enquetSol = action;
    },

    setOrige(state, action) {
      state.Orige = action;
    },

    setAvenecement(state, action) {
      state.Avencement = action;
    },
    setEtat(state, action) {
      state.Etat = action;
    },
    setSecteurActiviteSecure(state, action) {
      state.SecteurActiviteSecure = action;
    },

    setCommerciaux(state, actions) {
      state.commerciaux = actions;
    },
    setClientsComptable(state, action) {
      state.ClientsComptable = action;
    },
    setStatusClientComptable(state, action) {
      state.StatutsClientsComptable = action;
    },
  },
  actions: {
    getCommerciaux() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "commerciaux";
      fetch(url + "?action=" + action + "&table=" + table)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setCommerciaux", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getOrigine() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "U1:V40";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setOrige", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getProduitFamill() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "AG2:AG30";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setProduitFamill", da.data);
        })
        .catch((err) => console.log(err.message));
    },

    getClientsComptable() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "Z1:Z40";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setClientsComptable", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getStatusClientComptable() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "Y01:Y20";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setStatusClientComptable", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getSecteurActiviteSecure() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "AE1:AE70";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setSecteurActiviteSecure", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getenquetSol() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "AC1:AC10";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setenquetSol", da.data);
        })
        .catch((err) => console.log(err.message));
    },

    getEtat() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "X1:X20";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setEtat", da.data);
        })
        .catch((err) => console.log(err.message));
    },
    getAvencement() {
      var url =
        "https://script.google.com/macros/s/AKfycbzPPuXS4qi9PcH1LQ_eOeHF7lA4B3qUvDCwfH9rcMjhKma3XTI-zPyELh_HTw9VUXtzOA/exec";
      // var groupe = this.state.groupe;
      var action = "read";
      var table = "filtres";
      var rang = "AA1:AA20";
      fetch(url + "?action=" + action + "&table=" + table + "&range=" + rang)
        .then((res) => res.json())
        .then((da) => {
          this.commit("setAvenecement", da.data);
        })
        .catch((err) => console.log(err.message));
    },
  },
});
